import AppBar from '@material-ui/core/AppBar';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PeopleIcon from '@material-ui/icons/People';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import PhonelinkSetupIcon from '@material-ui/icons/PhonelinkSetup';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import { AccessLevels } from '../../config/access.levels';
import { AccountCircle } from '@material-ui/icons';
import { Link, useLocation } from 'react-router-dom';
import { Routes } from 'config/routes';
import { createStyles, makeStyles, Theme, ThemeProvider } from '@material-ui/core/styles';
import { logout } from 'redux/actions/session.actions';
import { myTheme } from '../Tools';
import { resetStore } from '../../redux/actions/types.actions';
import { useThunkDispatch, useTypedSelector } from 'hooks';
import { Environment } from 'utils/environment';
import { RenderIf } from '../Tools/Utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
    buttons: {
      width: '100%',
      backgroundColor: 'inherit',
      color: 'inherit',
    },
    myroot: {
      width: '100%',
      height: '56px',
      align: screenLeft,
    },
    sectionDesktop: {
      display: 'flex',
      gap: '4px',
    },
    grow: {
      flexGrow: 1,
    },
    divider: {
      minWidth: '1000px',
    },
    nav: {
      transition: 'all 0.3s ease',
      margin: '0 2px',
      borderRadius: '8px',
      minWidth: '90px',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        transform: 'translateY(-2px)',
      },
      '&.Mui-selected': {
        backgroundColor: '#ffffff',
        color: '#343c89',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        '&:hover': {
          backgroundColor: '#ffffff',
          transform: 'translateY(-2px)',
        },
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1.6rem',
      },
      '& .MuiBottomNavigationAction-label': {
        fontSize: '0.75rem',
        fontWeight: 500,
      },
      '& .MuiBottomNavigationAction-label.Mui-selected': {
        fontSize: '0.8rem',
        fontWeight: 600,
      },
    },
    appBar: {
      boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
      background: 'linear-gradient(135deg, #343c89 0%, #4a5aaa 100%)',
    },
    toolbar: {
      minHeight: '64px',
      padding: '0 24px',
    },
    logo: {
      height: '48px',
      marginRight: '16px',
      filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2))',
      transition: 'transform 0.3s ease',
      '&:hover': {
        transform: 'scale(1.05)',
      },
    },
    accountButton: {
      transition: 'all 0.3s ease',
      borderRadius: '8px',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        transform: 'translateY(-2px)',
      },
    },
  }),
);

function Navigation() {
  const classes = useStyles();
  const location = useLocation();

  const dispatch = useThunkDispatch();

  const user = useTypedSelector((s) => s.session.user);
  const role = user?.role?.accessLevel;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const isMenuOpen = Boolean(anchorEl);

  const [selectedNav, setSelectedNav] = React.useState<string>(() => {
    const paths = [
      {
        url: Routes.dashboard,
        name: 'dashboard',
      },
      {
        url: Routes.workshop,
        name: 'talleres',
      },
      {
        url: Routes.comisionist,
        name: 'comisionistas',
      },
      {
        url: Routes.workshopTypes,
        name: 'tipostalleres',
      },
      {
        url: Routes.providers,
        name: 'proveedores',
      },
      {
        url: Routes.users,
        name: 'usuarios',
      },
      {
        url: Routes.devices,
        name: 'dispositivos',
      },
      {
        url: Routes.profile,
        name: 'cuenta',
      },
      {
        url: Routes.systemParameters,
        name: 'systemParameters',
      }
    ];
    const foundPath = paths.find((path) => location.pathname.includes(path.url));

    return foundPath ? foundPath.name : '';
  });

  const handleNavChange = (_event: React.ChangeEvent<{}>, value: string) => {
    if (value === 'cuenta') {
      setAnchorEl(null);
      handleProfileMenuOpen(_event as any);
      return;
    }
    setSelectedNav(value);
  };

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedNav('');
  };

  const onCLick = () => {
    dispatch(resetStore());
    dispatch(logout());
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      PaperProps={{
        style: {
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
          marginTop: '8px',
          minWidth: '200px',
        },
      }}
    >
      <Link to={Routes.profile} style={{ textDecoration: 'none', color: '#343c89' }}>
        <MenuItem
          onClick={handleMenuClose}
          style={{
            padding: '12px 20px',
            fontSize: '14px',
            fontWeight: 500,
            transition: 'background-color 0.2s ease',
          }}
        >
          <AccountCircleIcon style={{ marginRight: 12, fontSize: '20px' }} />
          Perfíl
        </MenuItem>
      </Link>
      <Link to={Routes.help} style={{ textDecoration: 'none', color: '#343c89' }}>
        <MenuItem
          onClick={handleMenuClose}
          style={{
            padding: '12px 20px',
            fontSize: '14px',
            fontWeight: 500,
            transition: 'background-color 0.2s ease',
          }}
        >
          <HelpOutlineIcon style={{ marginRight: 12, fontSize: '20px' }} />
          Ayuda y Soporte
        </MenuItem>
      </Link>
      {role === AccessLevels.Admin && (
        <Link to={Routes.systemParameters} style={{ textDecoration: 'none', color: '#343c89' }}>
          <MenuItem
            onClick={handleMenuClose}
            style={{
              padding: '12px 20px',
              fontSize: '14px',
              fontWeight: 500,
              transition: 'background-color 0.2s ease',
            }}
          >
            <SettingsIcon style={{ marginRight: 12, fontSize: '20px' }} />
            Ajustes
          </MenuItem>
        </Link>
      )}
      <Link to={Routes.login} style={{ textDecoration: 'none', color: '#d32f2f' }}>
        <MenuItem
          onClick={onCLick}
          style={{
            padding: '12px 20px',
            fontSize: '14px',
            fontWeight: 500,
            borderTop: '1px solid #f0f0f0',
            marginTop: '4px',
            transition: 'background-color 0.2s ease',
          }}
        >
          <ExitToAppIcon style={{ marginRight: 12, fontSize: '20px' }} />
          Cerrar Sesión
        </MenuItem>
      </Link>
    </Menu>
  );

  return (
    <ThemeProvider theme={myTheme}>
      <div className={classes.divider}>
        <AppBar position="static" className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            {!Environment.hideMarks && (
              <img
                src={process.env.PUBLIC_URL + 'Logo.png'}
                alt="Logo GEO"
                className={classes.logo}
              />
            )}
            <div className={classes.grow} />

            <div className={classes.sectionDesktop}>
              <RenderIf
                condition={
                  role > AccessLevels.Coordinator && role !== AccessLevels.FinanceManager
                }
              >
                <Link to={Routes.dashboard}>
                  <BottomNavigation value={selectedNav} onChange={handleNavChange} showLabels>
                    <BottomNavigationAction
                      className={classes.nav}
                      label="Pendientes"
                      value="dashboard"
                      icon={<DashboardIcon />}
                    ></BottomNavigationAction>
                  </BottomNavigation>
                </Link>
              </RenderIf>

              {role !== AccessLevels.HelpDesk && role !== AccessLevels.FinanceManager && (
                <Link to={Routes.workshop}>
                  <BottomNavigation value={selectedNav} onChange={handleNavChange} showLabels>
                    <BottomNavigationAction
                      className={classes.nav}
                      label="Talleres"
                      value="talleres"
                      icon={<HomeRepairServiceIcon />}
                    ></BottomNavigationAction>
                  </BottomNavigation>
                </Link>
              )}

              {role !== AccessLevels.HelpDesk && new Array('Admin', 'FinanceManager', 'CommercialManager').includes(user?.role?.name) && (
                <Link to={Routes.comisionist}>
                  <BottomNavigation value={selectedNav} onChange={handleNavChange} showLabels>
                    <BottomNavigationAction
                      className={classes.nav}
                      label="Comisionistas"
                      value="comisionistas"
                      icon={<PeopleIcon />}
                    ></BottomNavigationAction>
                  </BottomNavigation>
                </Link>
              )}
              {role > AccessLevels.CommercialManager &&
              role !== AccessLevels.FinanceManager ? (
                <Link to={Routes.workshopTypes}>
                  <BottomNavigation value={selectedNav} onChange={handleNavChange} showLabels>
                    <BottomNavigationAction
                      className={classes.nav}
                      label="Tipos Taller"
                      value="tipostalleres"
                      icon={<BuildCircleIcon />}
                    ></BottomNavigationAction>
                  </BottomNavigation>
                </Link>
              ) : (
                <div />
              )}
              {role > AccessLevels.CommercialManager &&
              role !== AccessLevels.FinanceManager ? (
                <Link to={Routes.providers}>
                  <BottomNavigation value={selectedNav} onChange={handleNavChange} showLabels>
                    <BottomNavigationAction
                      className={classes.nav}
                      label="Proveedores"
                      value="proveedores"
                      icon={<EmojiPeopleIcon />}
                    />
                  </BottomNavigation>
                </Link>
              ) : (
                <div />
              )}
              {role > AccessLevels.Coordinator && role !== AccessLevels.FinanceManager ? (
                <Link to={Routes.users}>
                  <BottomNavigation value={selectedNav} onChange={handleNavChange} showLabels>
                    <BottomNavigationAction
                      className={classes.nav}
                      label="Usuarios"
                      value="usuarios"
                      icon={<PeopleIcon />}
                    />
                  </BottomNavigation>
                </Link>
              ) : (
                <div />
              )}
              {role > AccessLevels.CommercialManager &&
              role !== AccessLevels.FinanceManager ? (
                <Link to={Routes.devices}>
                  <BottomNavigation value={selectedNav} onChange={handleNavChange} showLabels>
                    <BottomNavigationAction
                      className={classes.nav}
                      label="Dispositivos"
                      value="dispositivos"
                      icon={<PhonelinkSetupIcon />}
                    />
                  </BottomNavigation>
                </Link>
              ) : (
                <div />
              )}

              <BottomNavigation showLabels>
                <BottomNavigationAction
                  onClick={handleProfileMenuOpen}
                  label="Cuenta"
                  icon={<AccountCircle />}
                  className={classes.accountButton}
                />
              </BottomNavigation>
              {renderMenu}
            </div>
          </Toolbar>
        </AppBar>
      </div>
    </ThemeProvider>
  );
}

export { Navigation };
